export default "__VITE_ASSET__ugGnsW6G__"